import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";
import { registerYup } from "../Schema/register";
import usePushNotifications, {
  sendTestNotification,
} from "../utils/notificationManager";
import cities from "../constants/turkey_cities_full.json";
import BackGroundColor from "../CommanComponents/BackGroundColor";
import api from "../utils/api";

function Register() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [isNight, setIsNight] = useState(false);
  const navigate = useNavigate();
  const { subscription, error, isLoading } = usePushNotifications();
  const roleArray = [
    {
      key: "student",
      value: "Öğrenci",
      description: " içerikleride faydalanırsın ",
    },
    {
      key: "teacher",
      value: "Öğretmen",
      description:
        " içerikleri faydalanmazsın fakat öğretmen dayfasının ücretsiz kullanırsun ",
    },
  ];

  const [districts, setDistricts] = useState([]);

  const { values, errors, touched, handleChange, handleSubmit, setFieldValue } =
    useFormik({
      initialValues: {
        username: "",
        email: "",
        password: "",
        city: "",
        district: "",
        role: "",
        score: [],
        verify: false,
        subscription: null,
      },
      onSubmit: submit,
      validationSchema: registerYup,
    });

  const handleCityChange = (e) => {
    const cityName = e.target.value;
    setFieldValue("city", cityName);
    setFieldValue("district", ""); // İl değiştiğinde ilçeyi sıfırla

    const city = cities.find((c) => c.il === cityName);
    setDistricts(city ? city.ilceler : []);
  };

  // Subscription güncellemesi
  useEffect(() => {
    if (subscription) {
      // console.log("🔔 PWA Subscription form'a ekleniyor:", subscription);
      setFieldValue("subscription", subscription);
    }
  }, [subscription, setFieldValue]);

  async function submit(values, { resetForm }) {
    try {
      setIsSubmitting(true);
      setSubmitStatus(null);

      const payload = {
        username: values.username,
        email: values.email,
        password: values.password,
        city: values.city,
        district: values.district,
        role: values.role,
        score: values.score || [],
        verify: values.verify || false,
        subscription: subscription ? subscription.toJSON() : null,
      };

      // console.log("📨 PWA Register payload:", payload);
      const res = await api.post("register", payload);
      // const res = await axios.post(
      //   import.meta.env.VITE_REACT_APP_SERVER_URL + "register",
      //   payload,
      // );

      if (res.status === 200) {
        setSubmitStatus("success");
        // Başarılı kayıt bildirimi gönder
        if (subscription) {
          await sendTestNotification(
            "Kayıt Başarılı! 🎉",
            "Hesabınızı onaylamak için kodu girin.",
          );
        }
        navigate("/verification", { state: { email: values.email } });
        resetForm();
      }
    } catch (error) {
      console.error("Kayıt başarısız", error.response?.data || error.message);
      console.error("Full error:", error.response);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div
      className="min-h-screen flex flex-col justify-center items-center
     bg-yellow-100 relative overflow-hidden"
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
      }}
    >
      {/* Background elements */}
      <BackGroundColor />

      {/* Content */}
      <div className="z-10 bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <h1 className="text-3xl text-blue-600 font-bold mb-2">
            Kids English
          </h1>
          <p className="text-lg text-purple-500 font-semibold">
            Let's Learn Together!
          </p>
        </div>

        <div className="w-full">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col justify-center items-center p-4 gap-6">
              {/* Username */}
              <div className="flex flex-col gap-2 w-full">
                <label className="block text-lg font-bold text-orange-500">
                  Kullancı adı
                </label>
                <input
                  type="text"
                  name="username"
                  value={values.username}
                  onChange={handleChange}
                  className="w-full h-12 text-xl rounded-full px-4 outline-none border-2
                   border-purple-300 focus:border-purple-500"
                  placeholder="username"
                />
                {errors.username && touched.username && (
                  <p className="mt-1 text-sm text-red-600">{errors.username}</p>
                )}
              </div>

              {/* Email */}
              <div className="flex flex-col gap-2 w-full">
                <label className="block text-lg font-bold text-orange-500">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  className="w-full h-12 text-xl rounded-full px-4 outline-none border-2
                   border-purple-300 focus:border-purple-500"
                  placeholder="eposta-adresiniz@ornek.com"
                />
                {errors.email && touched.email && (
                  <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                )}
              </div>

              {/* City and District Selection */}
              <div className="flex flex-col gap-2 w-full">
                <label className="block text-lg font-bold text-orange-500">
                  Adres
                </label>

                {/* İl seçimi */}
                <select
                  name="city"
                  value={values.city}
                  onChange={handleCityChange}
                  className={`w-full h-12 text-xl rounded-full pl-4 pr-12 outline-none border-2
                     border-purple-300 focus:border-purple-500 appearance-none ${
                       !values.city ? "text-gray-400" : "text-black"
                     }`}
                  style={{
                    color: !values.city ? "#9CA3AF" : "#000000",
                    backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,${encodeURIComponent(
                      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 7.5L10 12.5L15 7.5" stroke="%236B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    )}")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 16px center",
                    backgroundSize: "20px",
                  }}
                >
                  <option value="" style={{ color: "#9CA3AF" }}>
                    İl Seçiniz
                  </option>
                  {cities.map((city) => (
                    <option
                      key={city.il}
                      value={city.il}
                      style={{ color: "#000000" }}
                    >
                      {city.il}
                    </option>
                  ))}
                </select>
                {errors.city && touched.city && (
                  <p className="mt-1 text-sm text-red-600">{errors.city}</p>
                )}

                {/* İlçe seçimi */}
                <select
                  name="district"
                  value={values.district}
                  onChange={handleChange}
                  disabled={!values.city}
                  className={`w-full h-12 text-xl rounded-full pl-4 pr-12
                     outline-none border-2 border-purple-300 focus:border-purple-500 disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none ${
                       !values.district ? "text-gray-400" : "text-black"
                     }`}
                  style={{
                    color: !values.district ? "#9CA3AF" : "#000000",
                    backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,${encodeURIComponent(
                      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 7.5L10 12.5L15 7.5" stroke="%236B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    )}")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 16px center",
                    backgroundSize: "20px",
                  }}
                >
                  <option value="" style={{ color: "#9CA3AF" }}>
                    {values.city ? "İlçe Seçiniz" : "Önce İl Seçiniz"}
                  </option>
                  {districts.map((district) => (
                    <option
                      key={district}
                      value={district}
                      style={{ color: "#000000" }}
                    >
                      {district}
                    </option>
                  ))}
                </select>
                {errors.district && touched.district && (
                  <p className="mt-1 text-sm text-red-600">{errors.district}</p>
                )}
              </div>

              {/* Role */}
              <div className="flex flex-col gap-2 w-full">
                <label className="block text-lg font-bold text-orange-500">
                  Kullanıcı Tipi
                </label>
                <select
                  name="role"
                  value={values.role}
                  onChange={handleChange}
                  className={`w-full h-12 text-xl rounded-full pl-4 pr-12 outline-none
                    border-2 border-purple-300 focus:border-purple-500 appearance-none ${
                      !values.role ? "text-gray-400" : "text-black"
                    }`}
                  style={{
                    color: !values.role ? "#9CA3AF" : "#000000",
                    backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,${encodeURIComponent(
                      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 7.5L10 12.5L15 7.5" stroke="%236B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    )}")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 16px center",
                    backgroundSize: "20px",
                  }}
                >
                  <option value="" disabled style={{ color: "#9CA3AF" }}>
                    Kullanıcı tipi seçiniz
                  </option>
                  {roleArray.map((item, index) => (
                    <option
                      key={index}
                      value={item.key}
                      style={{ color: "#000000" }}
                    >
                      {item.value}
                    </option>
                  ))}
                </select>

                {/* Seçilen role göre dinamik alt bilgilendirme kutusu */}
                {values.role && (
                  <div className="mt-1 text-sm text-blue-600 bg-blue-50 px-4 py-2 rounded-xl border border-blue-200 animate-fade-in">
                    💡{" "}
                    {roleArray.find((r) => r.key === values.role)?.description}
                  </div>
                )}

                {errors.role && touched.role && (
                  <p className="mt-1 text-sm text-red-600">{errors.role}</p>
                )}
              </div>

              {/* Password */}
              <div className="flex flex-col gap-2 w-full">
                <label className="block text-lg font-bold text-orange-500">
                  şifre
                </label>
                <input
                  type="password"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  className="w-full h-12 text-xl rounded-full px-4 outline-none border-2 border-purple-300 focus:border-purple-500"
                  placeholder="••••••••"
                />
                {errors.password && touched.password && (
                  <p className="mt-1 text-sm text-red-600">{errors.password}</p>
                )}
              </div>

              {/* Submit */}
              <div className="w-full mt-4">
                <button
                  className="bg-green-500 hover:bg-green-600 disabled:bg-gray-400 text-white text-xl
                  font-bold rounded-full w-full h-12 transition-colors duration-300 flex flex-col items-center justify-center"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Kayıt olunuyor..." : "Kayıt Ol"}
                  {/* <hr className="border-1 border-yellow-400 w-24" />
                  <span className="text-sm font-normal">Kayıt ol</span> */}
                </button>
              </div>

              <div className="mt-4 text-center flex gap-2">
                <span>If you have an account?</span>
                <button
                  onClick={() => navigate("/login")}
                  className="text-blue-500 hover:text-blue-700"
                  type="button"
                >
                  login
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Register;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useFormik } from "formik";
// import axios from "axios";
// import { registerYup } from "../Schema/register";
// import usePushNotifications, {
//   sendTestNotification,
// } from "../utils/notificationManager";
// import cities from "../constants/turkey_cities_full.json";
// import BackGroundColor from "../CommanComponents/BackGroundColor";
// import api from "../utils/api";

// function Register() {
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitStatus, setSubmitStatus] = useState(null);
//   const [isNight, setIsNight] = useState(false);
//   const navigate = useNavigate();
//   const { subscription, error, isLoading } = usePushNotifications();

//   const roleArray = [
//     { key: "student", value: "Student" },
//     { key: "teacher", value: "Teacher" },
//   ];

//   const [districts, setDistricts] = useState([]);

//   const { values, errors, touched, handleChange, handleSubmit, setFieldValue } =
//     useFormik({
//       initialValues: {
//         username: "",
//         email: "",
//         password: "",
//         city: "",
//         district: "",
//         role: "",
//         score: [],
//         verify: false,
//         subscription: null,
//       },
//       onSubmit: submit,
//       validationSchema: registerYup,
//     });

//   const handleCityChange = (e) => {
//     const cityName = e.target.value;
//     setFieldValue("city", cityName);
//     setFieldValue("district", ""); // İl değiştiğinde ilçeyi sıfırla

//     const city = cities.find((c) => c.il === cityName);
//     setDistricts(city ? city.ilceler : []);
//   };

//   // Subscription güncellemesi
//   useEffect(() => {
//     if (subscription) {
//       // console.log("🔔 PWA Subscription form'a ekleniyor:", subscription);
//       setFieldValue("subscription", subscription);
//     }
//   }, [subscription, setFieldValue]);

//   async function submit(values, { resetForm }) {
//     try {
//       setIsSubmitting(true);
//       setSubmitStatus(null);

//       // Debug: Form değerlerini kontrol et
//       // console.log("🔍 Form values before submit:", values);
//       // console.log("🔍 City:", values.city);
//       // console.log("🔍 District:", values.district);

//       const payload = {
//         username: values.username,
//         email: values.email,
//         password: values.password,
//         city: values.city,
//         district: values.district,
//         role: values.role,
//         score: values.score || [],
//         verify: values.verify || false,
//         subscription: subscription ? subscription.toJSON() : null,
//       };

//       console.log("📨 PWA Register payload:", payload);
//       const res = await api.post("register", payload);
//       // const res = await axios.post(
//       //   import.meta.env.VITE_REACT_APP_SERVER_URL + "register",
//       //   payload,
//       // );

//       if (res.status === 200) {
//         console.log(res.data, "dönene değeri");
//         setSubmitStatus("success");
//         // Başarılı kayıt bildirimi gönder
//         if (subscription) {
//           await sendTestNotification(
//             "Kayıt Başarılı! 🎉",
//             "Hesabınızı onaylamak için kodu girin.",
//           );
//         }
//         navigate("/verification", { state: { email: values.email } });
//         resetForm();
//       }
//     } catch (error) {
//       console.error("Kayıt başarısız", error.response?.data || error.message);
//       console.error("Full error:", error.response);
//       setSubmitStatus("error");
//     } finally {
//       setIsSubmitting(false);
//     }
//   }

//   return (
//     <div
//       className="min-h-screen flex flex-col justify-center items-center
//      bg-yellow-100 relative overflow-hidden"
//     >
//       {/* Background elements */}
//       <BackGroundColor />

//       {/* Content */}
//       <div className="z-10 bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
//         <div className="flex flex-col items-center mb-6">
//           <h1 className="text-3xl text-blue-600 font-bold mb-2">
//             Kids English
//           </h1>
//           <p className="text-lg text-purple-500 font-semibold">
//             Let's Learn Together!
//           </p>
//         </div>

//         <div className="w-full">
//           <form onSubmit={handleSubmit}>
//             <div className="flex flex-col justify-center items-center p-4 gap-6">
//               {/* Username */}
//               <div className="flex flex-col gap-2 w-full">
//                 <label className="block text-lg font-bold text-orange-500">
//                   UserName
//                 </label>
//                 <input
//                   type="text"
//                   name="username"
//                   value={values.username}
//                   onChange={handleChange}
//                   className="w-full h-12 text-xl rounded-full px-4 outline-none border-2
//                    border-purple-300 focus:border-purple-500"
//                   placeholder="username"
//                 />
//                 {errors.username && touched.username && (
//                   <p className="mt-1 text-sm text-red-600">{errors.username}</p>
//                 )}
//               </div>

//               {/* Email */}
//               <div className="flex flex-col gap-2 w-full">
//                 <label className="block text-lg font-bold text-orange-500">
//                   Email
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={values.email}
//                   onChange={handleChange}
//                   className="w-full h-12 text-xl rounded-full px-4 outline-none border-2
//                    border-purple-300 focus:border-purple-500"
//                   placeholder="your-email@example.com"
//                 />
//                 {errors.email && touched.email && (
//                   <p className="mt-1 text-sm text-red-600">{errors.email}</p>
//                 )}
//               </div>

//               {/* City and District Selection */}
//               <div className="flex flex-col gap-2 w-full">
//                 <label className="block text-lg font-bold text-orange-500">
//                   Adres
//                 </label>

//                 {/* İl seçimi */}
//                 <select
//                   name="city"
//                   value={values.city}
//                   onChange={handleCityChange}
//                   className={`w-full h-12 text-xl rounded-full pl-4 pr-12 outline-none border-2
//                      border-purple-300 focus:border-purple-500 appearance-none ${
//                        !values.city ? "text-gray-400" : "text-black"
//                      }`}
//                   style={{
//                     color: !values.city ? "#9CA3AF" : "#000000",
//                     backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,${encodeURIComponent(
//                       '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 7.5L10 12.5L15 7.5" stroke="%236B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//                     )}")`,
//                     backgroundRepeat: "no-repeat",
//                     backgroundPosition: "right 16px center",
//                     backgroundSize: "20px",
//                   }}
//                 >
//                   <option value="" style={{ color: "#9CA3AF" }}>
//                     İl Seçiniz
//                   </option>
//                   {cities.map((city) => (
//                     <option
//                       key={city.il}
//                       value={city.il}
//                       style={{ color: "#000000" }}
//                     >
//                       {city.il}
//                     </option>
//                   ))}
//                 </select>
//                 {errors.city && touched.city && (
//                   <p className="mt-1 text-sm text-red-600">{errors.city}</p>
//                 )}

//                 {/* İlçe seçimi */}
//                 <select
//                   name="district"
//                   value={values.district}
//                   onChange={handleChange}
//                   disabled={!values.city}
//                   className={`w-full h-12 text-xl rounded-full pl-4 pr-12
//                      outline-none border-2 border-purple-300 focus:border-purple-500 disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none ${
//                        !values.district ? "text-gray-400" : "text-black"
//                      }`}
//                   style={{
//                     color: !values.district ? "#9CA3AF" : "#000000",
//                     backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,${encodeURIComponent(
//                       '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 7.5L10 12.5L15 7.5" stroke="%236B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//                     )}")`,
//                     backgroundRepeat: "no-repeat",
//                     backgroundPosition: "right 16px center",
//                     backgroundSize: "20px",
//                   }}
//                 >
//                   <option value="" style={{ color: "#9CA3AF" }}>
//                     {values.city ? "İlçe Seçiniz" : "Önce İl Seçiniz"}
//                   </option>
//                   {districts.map((district) => (
//                     <option
//                       key={district}
//                       value={district}
//                       style={{ color: "#000000" }}
//                     >
//                       {district}
//                     </option>
//                   ))}
//                 </select>
//                 {errors.district && touched.district && (
//                   <p className="mt-1 text-sm text-red-600">{errors.district}</p>
//                 )}
//               </div>

//               {/* Role */}
//               <div className="flex flex-col gap-2 w-full">
//                 <label className="block text-lg font-bold text-orange-500">
//                   Role
//                 </label>
//                 <select
//                   name="role"
//                   value={values.role}
//                   onChange={handleChange}
//                   className={`w-full h-12 text-xl rounded-full pl-4 pr-12 outline-none
//                      border-2 border-purple-300 focus:border-purple-500 appearance-none ${
//                        !values.role ? "text-gray-400" : "text-black"
//                      }`}
//                   style={{
//                     color: !values.role ? "#9CA3AF" : "#000000",
//                     backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,${encodeURIComponent(
//                       '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 7.5L10 12.5L15 7.5" stroke="%236B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
//                     )}")`,
//                     backgroundRepeat: "no-repeat",
//                     backgroundPosition: "right 16px center",
//                     backgroundSize: "20px",
//                   }}
//                 >
//                   <option value="" disabled style={{ color: "#9CA3AF" }}>
//                     Select a role
//                   </option>
//                   {roleArray.map((item, index) => (
//                     <option
//                       key={index}
//                       value={item.key}
//                       style={{ color: "#000000" }}
//                     >
//                       {item.value}
//                     </option>
//                   ))}
//                 </select>
//                 {errors.role && touched.role && (
//                   <p className="mt-1 text-sm text-red-600">{errors.role}</p>
//                 )}
//               </div>

//               {/* Password */}
//               <div className="flex flex-col gap-2 w-full">
//                 <label className="block text-lg font-bold text-orange-500">
//                   Password
//                 </label>
//                 <input
//                   type="password"
//                   name="password"
//                   value={values.password}
//                   onChange={handleChange}
//                   className="w-full h-12 text-xl rounded-full px-4 outline-none border-2 border-purple-300 focus:border-purple-500"
//                   placeholder="••••••••"
//                 />
//                 {errors.password && touched.password && (
//                   <p className="mt-1 text-sm text-red-600">{errors.password}</p>
//                 )}
//               </div>

//               {/* Submit */}
//               <div className="w-full mt-4">
//                 <button
//                   className="bg-green-500 hover:bg-green-600 disabled:bg-gray-400 text-white text-xl
//                   font-bold rounded-full w-full h-12 transition-colors duration-300 flex flex-col items-center justify-center"
//                   type="submit"
//                   disabled={isSubmitting}
//                 >
//                   {isSubmitting ? "Registering..." : "Register"}
//                   <hr className="border-1 border-yellow-400 w-24" />
//                   <span className="text-sm font-normal">Kayıt ol</span>
//                 </button>
//               </div>

//               <div className="mt-4 text-center flex gap-2">
//                 <span>If you have an account?</span>
//                 <button
//                   onClick={() => navigate("/login")}
//                   className="text-blue-500 hover:text-blue-700"
//                   type="button"
//                 >
//                   login
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Register;
